exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.additional-menu[data-v-e8a43962] {\n  border-radius: 999px;\n  padding: 10px;\n  background-color: #ffffff;\n  -webkit-box-shadow: 4px 4px 4px 0 rgba(134, 134, 134, 0.2);\n          box-shadow: 4px 4px 4px 0 rgba(134, 134, 134, 0.2);\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  gap: 10px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-e8a43962","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/vue/navigation/AdditionalMenu.vue
// module id = CGwI
// module chunks = 1